/*
akhila    10/28/2022 3075154998 enable framework UX changes
 */
import React, {useState, useContext} from 'react';
import {makeStyles} from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import {Card} from '@material-ui/core';
import AddMediaType from './AddMediaType';
import SearchMediaType from './SearchMediaType';
import {ThemeContext} from '../../../../themes/ThemeProvider';
import MediaUsage from './Usage';

const useStyles = makeStyles((theme) => ({
  'root': {
    flexGrow: 1,
    width: '100%',
    borderRadius: '5px',
  },
  'padding': {
    padding: '40px',
  },
  'MuiTabScrollButton-root': {
    color: 'black',
  },
  'demo1': {
    color: 'white',
    borderRadius: '6px',
  },
  'searchRuleButton': {
    margin: '-8px 0 8px',
  },
  'cardStyles': {
    backgroundColor: '#FFF',
    padding: '15px',
    marginBottom: 10,
    borderRadius: 8,
  },
}));

export default function EventTacticSubTabs() {
  const classes = useStyles();
  const {reusableInputStyles} = useContext(ThemeContext);
  const classes1 = reusableInputStyles();
  const [tabValue, setTabValue] = useState(0);
  const [usageState, setUsageState] = useState(false);
  const [mediaName, setMediaName] = useState('');
  const [isCopyData, setIsCopyData] = useState(false);
  const [code, setCode] = useState('');
  return (
    <Card className={` ${classes1.cardBordernoneStyles} mb-0`} elevation={0}>
      <div className={classes.root}>
        <Typography />
        <div className={classes.subContent}>
          {tabValue === 0 ? (
            <SearchMediaType
              setTabValue={setTabValue}
              setCode={setCode}
              mediaName={mediaName}
              setMediaName={setMediaName}
              setIsCopyData={setIsCopyData}
              setUsageState={setUsageState}
              usageState={usageState}
            />
          ) :
            tabValue === 1 ? (
              <AddMediaType
                setTabValue={setTabValue}
                setCode={setCode}
                code={code}
                mediaName={mediaName}
                setMediaName={setMediaName}
                isCopyData={isCopyData}
                setUsageState={setUsageState}
              />
            ) :
              tabValue === 2 ? (
                <MediaUsage setUsageState={setUsageState} setTabValue={setTabValue} />
              ) : null }
        </div>
      </div>
    </Card>
  );
}
